<ng-container>
  <div class="favorites-actions-dropdown" [class.favorites-menu-dropdown--collapsed]="collapsed()">
    @if (favorites()?.length ?? 0 > 0) {
      @if (displayMode() === 'OVERLAY') {
        <button ftrIconButton icon="ChevronRight" size="small" (click)="dropDownOpened.emit(menuSideNavItems())">
          Favorites actions
        </button>
      } @else {
        <button
          ftrButton
          color="grey"
          class="favorites-actions-dropdown__opener"
          [class.favorites-actions-dropdown__opener--collapsed]="collapsed()"
          [class.favorites-actions-dropdown__opener--active]="popover.isOpen()"
          aria-label="Favorites actions"
          ftrTooltip
          message="Favorites actions"
          [showDash]="false"
          position="right"
          [ngbPopover]="menuTemplate"
          #popover="ngbPopover"
          placement="bottom-start"
          container="body"
          [animation]="false"
          popoverClass="favorites-popover"
        >
          <svg [iconSize]="18" ftrIcon="MoreHorizontal" class="align-sub"></svg>
        </button>
      }
    } @else {
      <button
        ftrButton
        color="grey"
        class="favorites-actions-dropdown__opener"
        aria-label="Favorite this page"
        ftrTooltip
        message="Favorite this page"
        [showDash]="false"
        [position]="collapsed() ? 'right' : 'above'"
        (click)="addFavoriteAction()"
      >
        <svg [iconSize]="18" ftrIcon="Add" class="align-sub"></svg>
      </button>
    }
  </div>
</ng-container>
<ng-template #menuTemplate>
  <ftr-menu [menuItems]="menuItems" cdkTrapFocus cdkTrapFocusAutoCapture="true" />
</ng-template>
